import cn from 'classnames';

import Clock from 'components/icons/Clock';
import Lightning from 'components/icons/illustrative/Lightning';

const MealCookTime = ({ textClass, prepMinutes, showClock = true, showLightningBolt = false }) => {
  if (!prepMinutes) return null;

  return (
    <div className="flex flex-wrap items-center">
      {showClock && <Clock />}
      {showLightningBolt && <Lightning />}
      <p className={cn(textClass)}>{prepMinutes} min</p>
    </div>
  );
};

MealCookTime.propTypes = {
  textClass: PropTypes.string,
  prepMinutes: PropTypes.string,
  showClock: PropTypes.bool,
  showLightningBolt: PropTypes.bool,
};

export default MealCookTime;
